import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Image, Button} from '@salesforce/retail-react-app/app/components/shared/ui'

import {getUrl} from '../../../../utils/cloudinary-utils'

const Close = ({setStoreDetails}) => {
    const intl = useIntl()

    return (
        <Button
            onClick={() => setStoreDetails(null)}
            aria-label={intl.formatMessage({
                id: 'select_store_modal.close_store_details',
                defaultMessage: 'Close Store Details'
            })}
            variant="unstyled"
            display="flex"
            marginLeft="auto"
            alignItems="center"
            justifyContent="center"
            width="48px"
            height="48px"
            marginTop={{base: '-10px', lg: '-20px'}}
            marginRight={{base: '-10px', lg: '-20px'}}
        >
            <Image
                display={{base: 'none', lg: 'block'}}
                alt={intl.formatMessage({
                    id: 'select_store_modal.close_store_details',
                    defaultMessage: 'Close Store Details'
                })}
                width="16px"
                height="13px"
                src={getUrl('UIImages/images/arrow-right.svg')}
            />
            <Image
                display={{base: 'block', lg: 'none'}}
                alt={intl.formatMessage({
                    id: 'select_store_modal.close_store_details',
                    defaultMessage: 'Close Store Details'
                })}
                width="16px"
                height="13px"
                src={getUrl('UIImages/images/close.svg')}
            />
        </Button>
    )
}

Close.propTypes = {
    setStoreDetails: PropTypes.func.isRequired
}

export default Close
